export { CategoryService, Category } from './lib/category.service';
export * from './lib/categories-data-access-category.module';
